/**
 * Monster Onesie — size guide dialog (BRIEF §5.6).
 *
 * The fit sentence is merchant-editable rich text, so the size-guide link
 * inside it is an ordinary <a href="#monster-size-guide">. This component
 * intercepts clicks on that anchor anywhere within it and opens the native
 * <dialog> instead of jumping.
 *
 * Native <dialog>.showModal() gives focus trapping, Escape-to-close and the
 * top-layer backdrop for free — no library, no focus-management code of our
 * own to get wrong.
 *
 * If the dialog is missing (no custom.size_guide metafield) the link is left
 * alone to behave as a plain anchor rather than becoming a dead click.
 */

const HREF = '#monster-size-guide';

class MonsterSizeGuide extends HTMLElement {
  #dialog = null;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.addEventListener('click', this.#onClick);
    this.#dialog.addEventListener('click', this.#onBackdropClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const link = event.target.closest?.(`a[href="${HREF}"]`);
    if (link) {
      event.preventDefault();
      this.#dialog.showModal();
      return;
    }

    if (event.target.closest?.('[data-size-guide-close]')) {
      this.#dialog.close();
    }
  };

  /**
   * Click outside the panel closes. The dialog element itself fills the
   * viewport, so a click landing on it rather than on the panel is a
   * backdrop click.
   */
  #onBackdropClick = (event) => {
    if (event.target === this.#dialog) this.#dialog.close();
  };
}

if (!customElements.get('monster-size-guide')) {
  customElements.define('monster-size-guide', MonsterSizeGuide);
}
